module.exports = __webpack_public_path__ + "img/scooter.0bb5b6be.png";